export default __webpack_public_path__ + "static/media/weight-icon.eaffdc16.svg";